import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoggerService, normalizeHttpError, OccEndpointsService, Product } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProductOfTheMonthAdapter } from './product-of-the-month.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccProductOfTheMonthAdapter implements ProductOfTheMonthAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  load(): Observable<Product> {
    const url = this.occEndpoints.buildUrl('productOfTheMonth');
    return this.http.get<Product>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
